<template>
	<div v-if="message != ''" class="px-3 py-2 border radius-0 text-center d-block mb-3" style="background-color: rgb(255, 210, 195); border-color: rgb(247, 111, 111) !important;">
    <p class="mb-0 body-2-1 w-75 mx-auto">{{message}}</p>
    <p v-if="detail" class="mb-0 mt-1 body-3-3-1 w-75 mx-auto text-break">{{detail}}</p>
  </div>
</template>
<script>
	export default{
		props: {
			message: {
				type: String,
				default: ''
			},
			detail: {
				type: String,
				default: ''
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/hotel/concierge/general/ErrorMessage.vue